<script>
    import { onMount } from 'svelte'

    export let delay = 0

    let visible = delay > 0 ? false : true

    onMount(() => {
        if (delay > 0) {
            setTimeout(() => {
                visible = true
            }, delay)
        }
    })
</script>

<div class="spinner-container d-flex justify-content-center align-items-center fade-in">
    {#if visible}
        <div class="fade-in">
            <div class="spinner-border loading-spinner mb-5 mt-5 text-danger" role="status" />
        </div>
    {/if}
</div>

<style>
    /* Add a keyframe animation for the opacity */
    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }

    .fade-in {
        animation: fadeIn 0.3s ease-in-out;
    }

    .loading-spinner {
        width: 8rem !important;
        height: 8rem !important;
    }

    .spinner-container {
        min-height: 50vh;
    }
</style>
